/* eslint-disable no-undef */
import axios from 'axios'
// import { PendingUserListToManager } from '../types'

export type PendingUserListToManager = {
    users: Array<PendingUserVerification>,
    pageNum: number,
    totalPage: number,
    from: number,
    to: number,
    total: number,
    search: string
}

export type PendingUserVerification = {
    email: string,
    address: string,
    property: string
}

export const getPendingUserListToManageAsync = async (search: string = "", page: number = 0) => {
    let parametersStr = search != ""? page > 0 ? `?search=${search}&page=${page}` : `?search=${search}` : page > 0 ? `?page=${page}`: ""
      
    return await axios({
		url: `/User/GetPendingUserListToManage${parametersStr}`,
		method: "GET",
	});
}
